import React, { useCallback, useEffect } from 'react';
import Loading from '@ifit/mp-loading';
import GridSection from '../../../components/grid-section';
import InfiniteScrollRQ from '../../../components/infinite-scroll-rq';
import { setToolbarTitle } from '../../../store/to-native';
import { NotFound } from '../../../helpers/not-found';
import { getSearchState } from '../../search/state/search-state';
import { useParams } from 'react-router-dom';
import { FREE_CATEGORY_TITLE } from '../../../helpers/merge-slugs';
import { CategoryParams } from '../../routes';
import { useGetFilterOptions } from '../../../client/query/filter-options';
import { useEntitiesInfiniteQuery } from '../../../client/query/entities';

export const Subcategory: React.FC = () => {
  const { categorySlug, subcategorySlug }: CategoryParams = useParams();
  const { data: filterOptions } = useGetFilterOptions();
  const isFreeCategory = categorySlug === FREE_CATEGORY_TITLE;

  const filters = isFreeCategory
    ? {
        categories: [{ name: subcategorySlug }],
        freeOnly: true,
        languages: [],
      }
    : {
        categories: [
          {
            name: categorySlug,
            subcategories: subcategorySlug !== 'all' ? [subcategorySlug] : [],
          },
        ],
        languages: [],
      };

  const isInternational =
    decodeURIComponent(isFreeCategory ? subcategorySlug : categorySlug) ===
    'International';

  if (!isInternational) {
    filters.languages = ['English'];
  }

  const {
    dataMemo: { data: content = [], hasMoreItems },
    query: { isLoading, isFetching },
    fetchNextPageCallback,
  } = useEntitiesInfiniteQuery({
    ...filters,
    includedEntities: ['workout'],
  });

  const fetch = useCallback(() => fetchNextPageCallback(), [
    fetchNextPageCallback,
  ]);

  useEffect(() => {
    const decodedCategorySlug = decodeURIComponent(categorySlug);
    const decodedSubcategorySlug = decodeURIComponent(subcategorySlug);
    getSearchState().setViewContext(
      decodedCategorySlug === 'International'
        ? {
            languages: [subcategorySlug],
          }
        : {
            categories: [categorySlug],
          },
    );
    const subcategory = filterOptions?.subcategoryOptions?.find(
      sub => sub.value === decodedSubcategorySlug,
    );
    const category = filterOptions?.categoryOptions?.find(
      cat => cat.value === decodedCategorySlug,
    );
    setToolbarTitle(
      decodedSubcategorySlug !== 'all'
        ? subcategory?.display
        : category?.display,
    );
  }, [categorySlug, subcategorySlug, filterOptions]);

  if (isLoading) {
    return <Loading absolute />;
  }

  if (!content.length) {
    return <NotFound />;
  }

  return (
    <div className="subcategory-view">
      <InfiniteScrollRQ
        libraryCards={content}
        loadMore={fetch}
        hasMoreItems={hasMoreItems}
        isFetching={isFetching}
      >
        <GridSection />
      </InfiniteScrollRQ>
    </div>
  );
};

export default Subcategory;
